import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export function BackofficeProjectInterviewsPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams] = useSearchParams();
  const nextParams = new URLSearchParams(searchParams);
  nextParams.set('tab', 'interviews');
  const query = nextParams.toString();

  return <Navigate to={`/projects/${projectId ?? ''}${query ? `?${query}` : ''}`} replace />;
}
